import { Component, Input, OnInit, inject } from "@angular/core";
import { CautionService } from "@app/integrations/urm/services/caution.service";
import { PropertyService } from "@app/integrations/urm/services/property.service";
import { PropTenantAttribute } from "@app/integrations/urm/models/prop-tenant-attribute";
import { PropPropertyAttribute } from "@app/integrations/urm/models/prop-property-attribute";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatList } from "@angular/material/list";
import { TenantCautionListItemComponent } from "../tenant-caution-list-item/tenant-caution-list-item.component";
import { PropertyCautionListItemComponent } from "../property-caution-list-item/property-caution-list-item.component";

@Component({
  selector: "urm-caution-widget",
  templateUrl: "./caution-widget.component.html",
  styleUrls: ["./caution-widget.component.css"],
  imports: [
    MatProgressSpinner,
    MatIcon,
    MatTooltip,
    MatProgressBar,
    MatList,
    TenantCautionListItemComponent,
    PropertyCautionListItemComponent
  ]
})
export class CautionWidgetComponent implements OnInit {
  private clientConfigService = inject(ClientConfigService);
  cautionService = inject(CautionService);
  propertyService = inject(PropertyService);

  @Input()
  public externalPropertyReference: string = null;

  @Input()
  public mode: "icon" | "verbose" = "icon";

  public loading = true;
  public error = false;
  public cautions = false;

  public tenantCautions: PropTenantAttribute[] = [];

  public propertyCautions: PropPropertyAttribute[] = [];

  public urmEnabled = false;

  constructor() {
    this.urmEnabled = this.clientConfigService.config.urmServices.enabled;
  }

  ngOnInit() {
    console.log("creating caution widget, urm enabled: " + this.urmEnabled);
    let me = this;
    this.cautionService.hasCautions(this.externalPropertyReference).then(
      (value) => {
        me.loading = false;
        me.cautions = value;

        console.log("cautions detected? " + this.cautions);
        if (this.mode === "verbose" && this.cautions) {
          me.propertyService
            .loadPropertyById(this.externalPropertyReference)
            .then((value1) => {
              me.loadTenantCautions(value1.Proh_PropertyIdentity);
              me.loadPropertyCautions(value1.Proh_PropertyIdentity);
            });
        }
      },
      () => {
        this.loading = false;
        this.error = true;
      }
    );
  }

  public loadTenantCautions(propertyIdentity: number) {
    let me = this;
    me.cautionService
      .loadTenantAttributeByPropertyID(propertyIdentity)
      .then((value) => {
        me.tenantCautions = value;
        console.log("tenant cautions loaded: ", me.tenantCautions);
      });
  }

  public loadPropertyCautions(propertyIdentity: number) {
    let me = this;
    me.cautionService
      .loadPropertyAttributeCautionsByPropertyID(propertyIdentity)
      .then((value) => {
        me.propertyCautions = value;

        console.log("property cautions loaded: ", me.propertyCautions);
      });
  }
}
